import LetterConfigsList from './views/LetterConfigsList.vue'
import CreateLetterConfig from './views/CreateLetterConfig.vue'
import HomeLayout from '@/layouts/Home.vue'
import LetterConfigDetail from './views/LetterConfigDetail.vue'
import LetterRequests from './views/LetterRequests.vue'
import LetterRequestsApprover from './views/LetterRequestsApprover.vue'
import LetterRequestDetail from './views/LetterRequestDetail.vue'
import CreateLetterExternal from './views/external/CreateExternalLetters.vue'
import ExternalLettersDetail from './views/external/ExternalLettersDetail.vue'

export const LettersRoutes = [
  {
    path: '/letterConfigs',
    name: 'letterConfigs',
    component: LetterConfigsList,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['superadmin', 'admin'],
    },
  },
  {
    path: '/letterConfig/add',
    name: 'CreateLetterConfig',
    component: CreateLetterConfig,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['superadmin', 'admin'],
    },
  },
  {
    path: '/letterConfig/detail/:id',
    name: 'LetterConfigDetail',
    component: LetterConfigDetail,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['superadmin', 'admin'],
    },
  },
  {
    path: '/letterRequests',
    name: 'LetterRequests',
    component: LetterRequests,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['employee', 'supervisor'],
    },
  },
  {
    path: '/letterRequests/:id',
    name: 'LetterRequestsdetail',
    component: LetterRequestDetail,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['supervisor'],
    },
  },
  {
    path: '/letterRequests/approver',
    name: 'LetterRequestsApprover',
    component: LetterRequestsApprover,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['supervisor'],
    },
  },
  {
    path: '/letterExternals/create',
    name: 'CreateExternalLetters',
    component: CreateLetterExternal,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['superadmin', 'admin', 'RRHH'],
    },
  },
  {
    path: '/letterExternals/detail/:id',
    name: 'ExternalLetterDetail',
    component: ExternalLettersDetail,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['superadmin', 'admin', 'RRHH'],
    },
  },
]
